import type { FaireProductEntity } from "../../entity_types/product";

export const p_ngjxjhxerv: FaireProductEntity = {
  token: "p_ngjxjhxerv",
  type: "product",
  name: "SIMPLE ROUND ALPHABET INITIALS PENDANT NECKLACE_CWAJE215",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/17e225cfef4cd1839b777115f36a9008c1fb09760556e1ec45bf5b602273c096.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fdff523f67ba3968d9a9945a70e9a6e78d3f8d589e78b8ed4d2067a8cbdd22a4.jpeg",
    "https://cdn.faire.com/fastly/64f1bee8695ca7da826810d25ed27d526f5097683f37638c24b393ca0392ae25.jpeg",
    "https://cdn.faire.com/fastly/e39e24404cc35601b6e5ec80ae6e414b7c321a63777e69d34c522dc54f07725e.jpeg",
    "https://cdn.faire.com/fastly/503e4d7a3f014a486cd5d8aaefe5ef1da7d079ae3353161ecdbaae80776eb1fe.jpeg",
    "https://cdn.faire.com/fastly/166b835d604741aa6554bd11232a390755e71934544dd85057ff9ff5956c6c6d.jpeg",
    "https://cdn.faire.com/fastly/485867709ebbc97de06297470eeb188e3885f6ac3fecb3384895963d7fd083e5.jpeg",
    "https://cdn.faire.com/fastly/bd52f91285b95f227471525348275db9f4a997d421d648975a2e2c1230b22d81.jpeg",
    "https://cdn.faire.com/fastly/8160e23b474ab529f1f8f2e44ec129adef40b465109d919595ccb2d7e23afe6c.jpeg",
    "https://cdn.faire.com/fastly/65e96009234a59b17511428597ca3c693214d20ebc06f67009a4bdc89644f5b1.jpeg",
    "https://cdn.faire.com/fastly/da97feb8ca2944c706754fbf2ac7de644924ba21635c28b54f94619682e4c5df.jpeg",
    "https://cdn.faire.com/fastly/0acf0030dab213be36a423a1b43738c3d2daabc5eaaf5f5de3d81ebfda0dfedd.jpeg",
    "https://cdn.faire.com/fastly/a6a5e36d325370fefa672edad6bf85c88cd4344b64b66945d835f13039794ef8.jpeg",
    "https://cdn.faire.com/fastly/c30ca82d6cf8d2f8aacea9369aa9b2776584f6bff49d13a6bb1d8e3e732866e2.jpeg",
    "https://cdn.faire.com/fastly/26e1ff16a79d3753c8850da910c24fe28a98cbc4d9f6a9637d04fcf34ee68c81.jpeg",
    "https://cdn.faire.com/fastly/4008a0e07de4fcc0dbe4d0499fc0ada0e64d0a8042f30389047b1394f47fb66a.jpeg",
    "https://cdn.faire.com/fastly/7db94b6c015adc81489d35768c51ed45f364d4e7440c3a02b4ae94ba6251ee9a.jpeg",
    "https://cdn.faire.com/fastly/52994b3906ebc064162f1c454ed102adfbed1d8851cdd7fa583da93e02feabad.jpeg",
    "https://cdn.faire.com/fastly/1a4da37b17a5a3e0998ec3ecd8b4cd12ff9941e7364e41784e5b4d22c557e834.jpeg",
    "https://cdn.faire.com/fastly/9c133ca17b8f3531e8d1dc0b6d032533652d367d2b3600580b6c2e63b6b5f8f8.jpeg",
  ],
  priceDollars: 2.08,
  description: "CWAJE215  \n\n\nSIMPLE ROUND INITIALS PENDANT NECKLACE",
  tags: [],
  msrpDollars: 4.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:59.857Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
